var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gameStarted && _vm.isFinalStage)?_c('div',[(_vm.currentGame.game.gameType.code === 'defi')?_c('winner-defi'):_vm._e(),(_vm.currentGame.game.gameType.code === 'scenarios')?_c('winner-scenario'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }